<script lang="ts">
	// import { transformImage } from '$lib/utils.js'

	export let url = ''
	// export let editable = false
	export let size = 'm'
	export let username: string

	$: initials = username.charAt(0).toUpperCase()

	// async function uploadAvatar(event) {
	// 	const file = event.target.files[0]
	// 	const dataUrl = await transformImage(file)
	// 	// TODO: Upload avatar named after user?
	// 	url = dataUrl as string
	// 	// console.log({ dataUrl })
	// }
</script>

<div
	class:s={size === 's'}
	class:m={size === 'm'}
	class:l={size === 'l'}
	class="rounded-full bg-zinc-800 w-16 h-16 relative overflow-hidden flex justify-center items-center text-zinc-500"
	style="background-image: url({url}); background-repeat: no-repeat; background-size: contain"
>
	<!-- {#if editable}
		<label class="overlay">
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
				<path
					d="M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z"
				/>
			</svg>
			<input type="file" accept="image/*" on:change={uploadAvatar} />
		</label>
	{/if} -->
	<span>{initials}</span>
</div>

<style lang="postcss">
	.s {
		@apply font-medium w-5 h-5 text-xs;
	}

	.m {
		@apply font-medium w-6 h-6;
	}

	.l {
		@apply font-medium w-16 h-16 text-4xl;
	}

	/* .avatar:hover .overlay {
		display: flex;
	}

	.overlay {
		display: none;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
		position: absolute;
		background: hsla(0, 0%, 0%, 0.1);
	} */
</style>
